import { Card, Descriptions, DescriptionsProps, Flex, Tag, Typography } from "antd";
import dayjs from "dayjs";
import React, { useMemo, useState } from "react";
import { useWindowSize } from "rooks";
import { formatNumber } from "src/pages/dashboard/BinStatusPage/HeaterControls";
import { HourSelector } from "./HourSelector";
import { useQuery } from "@tanstack/react-query";
import { cycleAveragesQueryOptions } from "src/queries/getCycleAveragesPremierPlusOptions";

interface ReadingOnOffDisplayProps{
    binId: number | null | undefined;
}

export const ReadingOnOffDisplay : React.FC<ReadingOnOffDisplayProps> = ({ binId }) => {

    const [hours, setHour] = useState(2);

    const windowSize = useWindowSize();

    const AVG_FILLER = '----';
    const _cycleAveragesQueryOptions = cycleAveragesQueryOptions(binId, hours);

    const cycleAveragesQuery = useQuery({
        ..._cycleAveragesQueryOptions,
    });
    
    const onCycleItemsMoistureAvg = useMemo(() => {
        if (cycleAveragesQuery.data == null || cycleAveragesQuery.data?.numberOfSamples === 0) {
            return null;
        }
        return cycleAveragesQuery.data.onCycleInfo?.moistavg;

    }, [cycleAveragesQuery.data]);

    const onCycleGrainTempAvg = useMemo(() => {
        if (cycleAveragesQuery.data == null || cycleAveragesQuery.data?.numberOfSamples === 0) {
            return null;
        }
        return cycleAveragesQuery.data.onCycleInfo?.graintemp;

    }, [cycleAveragesQuery.data]);

    const offCycleItemsMoistureAvg = useMemo (() => {
        if (cycleAveragesQuery.data == null || cycleAveragesQuery.data?.numberOfSamples === 0) {
            return null;
        }
        return cycleAveragesQuery.data.offCycleInfo?.moistavg;
    }, [cycleAveragesQuery.data]);

    const offCycleGrainTempAvg = useMemo (() => {
        if (cycleAveragesQuery.data == null || cycleAveragesQuery.data?.numberOfSamples === 0) {
            return null;
        }
        return cycleAveragesQuery.data.offCycleInfo?.graintemp;
    }, [cycleAveragesQuery.data]);

    const onCycleItems: DescriptionsProps['items'] = [
        {
            label: "Moisture Avg.",
            children: <Typography.Text>{formatNumber(onCycleItemsMoistureAvg, { filler: AVG_FILLER, decimalPlaces: 2 })}</Typography.Text>,
        },
        {
            label: "Grain Temp Avg.",
            children: <Typography.Text>{formatNumber(onCycleGrainTempAvg, { filler: AVG_FILLER, decimalPlaces: 2 })}</Typography.Text>,
        },
        // {
        //     label: "Time On (hh:mm)",
        //     children: <Typography.Text>{formatTime(record.onCycleInfo.durationSeconds)}</Typography.Text>,
        // },
    ];

    const offCycleItems: DescriptionsProps['items'] = [
        {
            label: "Moisture Avg.",
            children: <Typography.Text>{formatNumber(offCycleItemsMoistureAvg, { filler: AVG_FILLER, decimalPlaces: 2 })}</Typography.Text>,
        },
        {
            label: "Grain Temp Avg.",
            children: <Typography.Text>{formatNumber(offCycleGrainTempAvg, { filler: AVG_FILLER, decimalPlaces: 2 })}</Typography.Text>,
        },
        // {
        //     label: "Time Off (hh:mm)",
        //     children: <Typography.Text>{formatTime(record.offCycleInfo.durationSeconds)}</Typography.Text>,
        // },
    ];

    const horizontal = () => {
        if (windowSize.innerWidth! <= 600) {
            return false;
        }
        else if (windowSize.innerWidth! <= 900) {
            return true;
        }
        else if (windowSize.innerWidth! > 900 && windowSize.innerWidth! < 1200) {
            return true;
        }
        else if (windowSize.innerWidth! >= 1200 && windowSize.innerWidth! < 1500) {
            return false;
        }
        else if (windowSize.innerWidth! >= 1500) {
            return true;
        }
        else
            return false;
    }

    return <>
        <Card style={{ width: "100%" }} styles={{
            title: {
                width: "100%",
            },
            body: {
                minWidth: horizontal() ? "460px" : "240px",
                width: "100%",
            }
        }} loading={cycleAveragesQuery.isFetching} title={<Flex gap="small">
            <span>Cycle Averages</span>
            <Tag>{formatNumber(cycleAveragesQuery.data?.numberOfSamples, { filler: "No Data", decimalPlaces: 0, suffix: " Samples" })}</Tag>
        </Flex>
        }>

            <Flex gap="middle" align="center" justify="center" >
                <Typography.Text>Choose Hours</Typography.Text>
                <HourSelector hours={hours} onHourChange={setHour} loading={false} />
            </Flex>
            <Flex gap={"middle"} justify="center" wrap="wrap" vertical={!horizontal()}>
                <Descriptions title="On Cycles Avg." labelStyle={{ width: "144px" }} bordered items={onCycleItems} size="small" column={1} />
                <Descriptions title="Off Cycles Avg." labelStyle={{ width: "144px" }} bordered items={offCycleItems} size="small" column={1} />
            </Flex>
        </Card>
    </>;
};